import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import get from 'lodash/get';

import pluralize from 'rebook/apps/utils/text/pluralize';
import { Genre, Niche, Tag } from 'rebook/apps/catalog/models';
import MultilineEllipsisText from 'rebook/apps/base/components/MultilineEllipsisText';

import styles from './style.scss';


const ListItem = ({ item, link }) => (
  <li className={classNames('billetContainer', styles.genreItem)}>
    <Link to={link}>
      <div className={styles.genre}>
        <div className={styles.genreInfo}>
          <big>
            <b>
              <MultilineEllipsisText maxLinesCount="2">
                {item.name}
              </MultilineEllipsisText>
            </b>
          </big>
          <span className={styles.genreBookCount}>
            {`${item.active_book_count} ${pluralize(item.active_book_count, 'книга', 'книги', 'книг')}`}
          </span>
        </div>
        <div className="shortArrow" />
      </div>
    </Link>
  </li>
);

const ListItemEmpty = () => (
  <li className={classNames('billetContainer', styles.genreItem)}>
    <div className={styles.genreInfoEmpty} />
    <div className={styles.genreBookCountEmpty} />
  </li>
);

const GenreList = ({ genres, niches, tags, maxElementsView }) => {
  let items = [];
  genres && genres.map((item) => {
    items.push({ ...item, type: 'genre' });
  });
  niches && niches.map((item) => {
    items.push({ ...item, type: 'niche' });
  });
  tags && tags.map((item) => {
    items.push({ ...item, type: 'tag' });
  });

  return (
    <ul className={classNames(styles.genreList, 'jest-genre-list')}>
      {!get(items, 'length') && (
        [...Array(5)].map((item, key) => (
          <ListItemEmpty key={`genreItemEmpty${key}`} />
        ))
      )}
      {
        items && items.length > 0 && items.map((item, index) => {
          if (maxElementsView > 0 && index >= maxElementsView) {
            return null;
          }

          let ItemInstance = '';

          if (item.type === 'genre') {
            ItemInstance = new Genre(item);
          }
          else if (item.type === 'niche') {
            ItemInstance = new Niche(item);
          }
          else if (item.type === 'tag') {
            ItemInstance = new Tag(item);
          }
          else {
            return null;
          }

          return (
            <ListItem item={item} link={ItemInstance.getLink()} key={get(item, 'id', index)} />
          );
        })
      }
    </ul>);
};

GenreList.propTypes = {
  items: PropTypes.array,
  maxElementsView: PropTypes.number,
  genres: PropTypes.array,
  niches: PropTypes.array,
  tags: PropTypes.array,
};

GenreList.defaultProps = {
  items: [],
  maxElementsView: 0,
  genres: [],
  niches: [],
  tags: [],
};

export default GenreList;
